import Task from "../../../../../shared/lib/html5-software-library/src/ranj/util/executor/Task";
import { applySearchParametersToObject } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import SaveEvent from "../../../../../shared/src/ranj/equalture/savegame/SaveEvent";
import GameConfigValidator, { validategameConfig } from "../model/validategameConfig";

export default class InitProblemSolvingGameTask extends Task {

    /**
     * 
     * @param {*} dispatcher 
     * @param {*} assetLibrary 
     * @param {*} gameConfig 
     * @param {*} gameAssets 
     * @param {*} languagePack 
     * @param {AppModel} appModel 
     */
    constructor(dispatcher, assetLibrary, gameConfig, gameAssets, languagePack, appModel) {
        super();
        
        this.execute = function(callback, progressCallback) {
            var configJSON = assetLibrary.getAsset("gameConfig");
            if (ranj.DEBUG) {
                applySearchParametersToObject(window.top.location.search, configJSON);
                window.document.addEventListener("keyup", this._handleKeyUp);
            }
            gameConfig.setPropertiesFromObject(configJSON);

            const result = validategameConfig(gameConfig, languagePack, gameAssets);
            if (result.length) {
                console.error(result);
                throw new Error("GameConfig invalid.");
            } else {
                console.log("GameConfig validated.");
            }

            callback(this);
        }

        this._handleKeyUp = function(e) {
            const c = String.fromCharCode(e.which);
            if (c == "R") {
                if (confirm("Are you sure you want to reset the savegame?")) {
                    dispatcher.dispatch(SaveEvent.CLEAR);
                    window.location.reload();
                }
            }
        }.bind(this);
    }

}